

import React, { memo } from 'react';
import cx from 'classnames';
import Button from '../../../Button';
import { FOOTER } from '../../styles/navModal';









/**
   * A modal footer component. Will not render the footer save button if
   * no onSave function is passed as a prop
   *
   * @return {React.Element}
   */
function ModalFooter(
{
  primaryAction,
  secondaryAction,
  primaryText,
  secondaryText,
  alignActionBtnsToEnd
})
{
  return (
    <div className={cx(FOOTER(alignActionBtnsToEnd), 'modal__footer')}>
      <Button
        className="first-button"
        type="PRIMARY"
        onClick={primaryAction}>

        {primaryText}
      </Button>
      {
      secondaryAction && secondaryText ?
      <Button type="TERTIARY" onClick={secondaryAction}>{secondaryText}</Button> :
      null}

    </div>);

}

export default memo(ModalFooter);